export default __webpack_public_path__ + "static/media/MAIN.210f5a79.png";